/**
 * Single checkout submit control: disable #place_order when the order cannot be paid.
 */

function checkoutForm() {
	return document.querySelector('[data-dc-checkout], form.checkout');
}

function placeOrderButton() {
	return document.querySelector('#place_order');
}

function fulfilmentChosen() {
	const method = checkoutForm()?.dataset.deliveryMethod || '';
	return method === 'collection' || method === 'delivery';
}

function paymentReady() {
	if (document.querySelector('#payment [data-payment-recovery]')) {
		return false;
	}

	const payment = document.querySelector('#payment');
	if (!payment) {
		return false;
	}

	if (payment.querySelector('input[name="payment_method"]:checked')) {
		return true;
	}

	if (payment.querySelector('.woocommerce-error')) {
		return false;
	}

	if (payment.querySelector('input[name="payment_method"]')) {
		return true;
	}

	return !payment.querySelector('.woocommerce-info, .woocommerce-notice');
}

function prescriptionReady() {
	const upload = document.querySelector('[data-prescription-upload]');
	if (!upload) {
		return true;
	}

	return Boolean(upload.querySelector('[data-prescription-list] li, .dc-prescription-upload__list li'));
}

function isCheckoutBusy() {
	const form = checkoutForm();
	return Boolean(form?.classList.contains('processing') || document.body.classList.contains('dc-checkout-busy'));
}

export function checkoutCanSubmit() {
	if (isCheckoutBusy()) {
		return false;
	}

	if (!fulfilmentChosen()) {
		return false;
	}

	if (!prescriptionReady()) {
		return false;
	}

	return paymentReady();
}

export function syncCheckoutSubmitState() {
	const button = placeOrderButton();
	if (!button) {
		return;
	}

	const allowed = checkoutCanSubmit();
	button.disabled = !allowed;
	button.setAttribute('aria-disabled', allowed ? 'false' : 'true');
	document.body.classList.toggle('dc-checkout-unpayable', !allowed);

	document.dispatchEvent(new CustomEvent('dc:checkout-submit-state', { detail: { allowed } }));
}

function bindRetry() {
	document.addEventListener('click', (event) => {
		const retry = event.target.closest('[data-checkout-retry]');
		if (!retry) {
			return;
		}

		event.preventDefault();
		if (typeof window.jQuery === 'undefined') {
			return;
		}

		window.jQuery(document.body).trigger('update_checkout');
	});
}

function setBusy(busy) {
	document.body.classList.toggle('dc-checkout-busy', busy);
	const form = checkoutForm();
	form?.classList.toggle('is-updating', busy);
	syncCheckoutSubmitState();
}

export function initCheckoutSubmit() {
	if (!document.body.classList.contains('woocommerce-checkout')) {
		return;
	}

	bindRetry();
	syncCheckoutSubmitState();

	const onUpdate = () => setBusy(true);
	const onUpdated = () => {
		setBusy(false);
		window.requestAnimationFrame(() => syncCheckoutSubmitState());
	};

	if (typeof window.jQuery !== 'undefined') {
		window.jQuery(document.body).on('update_checkout', onUpdate);
		window.jQuery(document.body).on('updated_checkout', onUpdated);
		window.jQuery(document.body).on('checkout_error', () => setBusy(false));
		window.jQuery(document).ajaxError((event, xhr, settings, thrown) => {
			const url = String(settings?.url || '');
			if (!url.includes('update_order_review') || thrown === 'abort') {
				return;
			}
			const form = checkoutForm();
			form?.classList.remove('processing');
			setBusy(false);
		});
	}

	document.body.addEventListener('update_checkout', onUpdate);
	document.body.addEventListener('updated_checkout', onUpdated);
	document.body.addEventListener('checkout_error', () => setBusy(false));
	document.addEventListener('dc:delivery-method', () => {
		window.requestAnimationFrame(() => syncCheckoutSubmitState());
	});

	const form = checkoutForm();
	if (form) {
		const observer = new MutationObserver(() => syncCheckoutSubmitState());
		observer.observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-delivery-method', 'class'] });
	}
}
